// extracted by mini-css-extract-plugin
export default {"heroImg":"Hero_heroImg__7AB8B","pin":"Hero_pin__TT4oP","hero":"Hero_hero__2GcVT"};